import { FallbackProps } from 'react-error-boundary'

export const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => (
  <div
    role="alert"
    className="flex flex-col items-center justify-center gap-4 p-8 text-center"
  >
    <p className="text-lg font-semibold text-red-600">오류가 발생했습니다</p>
    <pre className="max-w-md overflow-auto rounded bg-red-50 p-4 text-sm text-red-800">
      {error instanceof Error ? error.message : String(error)}
    </pre>
    <button
      onClick={resetErrorBoundary}
      className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
    >
      다시 시도
    </button>
  </div>
)
